import { TICKET_LATLNG} from './ticketTypes'

const initialState = {
    positionTicket: []
}

const positionTicketReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case TICKET_LATLNG:
            
            return {
                positionTicket: action.load
            }
    
        default:
          return state
    }

}


export default positionTicketReducer;